/** Object keys for unassociated temp files in tenant storage. */
export function isStagedTempFileKey(objectKey: string | null | undefined): boolean {
  if (!objectKey) return false;
  return objectKey.includes('/temp_file/');
}
